module.exports = __webpack_public_path__ + "img/arrow_disabled.f8ee4a98.svg";